import React, { createContext, useContext, useState, useCallback, useRef } from 'react';

const AlertContext = createContext();

export const useAlert = () => {
  const context = useContext(AlertContext);
  if (!context) {
    throw new Error('useAlert must be used within an AlertProvider');
  }
  return context;
};

export const AlertProvider = ({ children }) => {
  const [alert, setAlert] = useState(null);
  const timerRef = useRef(null);

  const showAlert = useCallback((message, type = 'success', duration = 3000) => {
    // Clear existing timer if any
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    
    // Set new alert
    setAlert({ message, type });

    // Auto-hide after duration
    timerRef.current = setTimeout(() => {
      setAlert(null);
      timerRef.current = null;
    }, duration);
  }, []);

  const hideAlert = useCallback(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    setAlert(null);
  }, []);

  return (
    <AlertContext.Provider value={{ showAlert, hideAlert, alert }}>
      {children}
    </AlertContext.Provider>
  );
};
